<template>
    <div>
        <Head :title="`${form.name}`"/>
        <div class="flex justify-start mb-8 max-w-3xl">
            <h1 class="text-3xl font-bold">
                <Link class="text-indigo-400 hover:text-indigo-600" href="/brands">Brands</Link>
                <span class="text-indigo-400 font-medium">/</span>
                <Link class="text-indigo-400 hover:text-indigo-600" href="edit">{{brand.name}}</Link>
                <span class="text-indigo-400 font-medium">/</span>
                Translations
            </h1>
        </div>
        <div class="w-full bg-white rounded-md shadow overflow-hidden">

            <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
                <loading-button class="btn-indigo ml-auto" type="botton" @click="saveTranslations">Save</loading-button>
            </div>
            <div class="-mb-8 -mr-6 p-8 w-full">
                Select locale
            <ul>
                <li v-for="locale in locales" v-on:click="changeLocale(locale)" style="cursor: pointer"><u>{{locale}}</u></li>
            </ul>
                <br>

            <div v-for="(langContent,lang) in form.formTranslations">
                <div v-if="lang === selectedLocale">
                <h1 class="text-3xl font-bold">Selected: {{lang}}</h1>
                <div v-for="(categoryContent,categoryName) in langContent">
                    <h2 class="text-xl font-bold">{{categoryName}}</h2>
                    <div v-for="(sectionContent,sectionName) in categoryContent">
                        <text-input style="margin-bottom: 10px" class=" w-full" v-model="form.formTranslations[lang][categoryName][sectionName]" :label="sectionName"/>
                        <hr style="margin-bottom: 10px">
                    </div>
                    <br>
                    <br>
                    <hr>
                    <br>
                    <br>
                </div>
                </div>

            </div>
            </div>
            <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
                <loading-button class="btn-indigo ml-auto" type="botton" @click="saveTranslations">Save</loading-button>
            </div>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import TextInput from '@/Shared/TextInput'
import LoadingButton from "@/Shared/LoadingButton";

export default {
    components: {
        Head,
        Icon,
        Link,
        LoadingButton,
        TextInput,
    },
    layout: Layout,
    props: {
        brand: Object,
        locales: Array,
        translations: Object,
        formTranslations: Object,
    },
    data() {
        return {
            lang: null,
            selectedLocale: null,
            form: this.$inertia.form({
                formTranslations: {},
            })
        }
    },
    beforeMount: function(){
        this.form.formTranslations = this.translations;
        console.log(this.form);
    },

    methods: {
        reset() {
            this.form = mapValues(this.form, () => null)
        },
        changeLocale(value) {
            this.selectedLocale = value;
        },
        saveTranslations() {
            this.form.post(`/brands/${this.brand.id}/translations`)
        },
    },
}
</script>
